import axios from '../helpers/axios';
import { logError } from '../services';
import {
  IEmailTemplate,
  IEmailTemplateDetails,
  IEmailTemplateSection,
  ISalesEmailTemplate,
  IDropdownResponse,
  ISalesEmailTemplateDetail,
  ITransformedEmailTemplate
} from '../models';

const salesBaseUrl = '/api/sales/tools/email-templates';
export const getEmailTemplates = async (): Promise<IEmailTemplate[]> => {
  try {
    const { data } = await axios.get(`/api/email-templates`);
    return data;
  } catch (error) {
    logError(error, 'getEmailTemplates failed');
    return Promise.reject(error.response.data);
  }
};

export const getEmailTemplateDetails = async (id: number): Promise<IEmailTemplateDetails> => {
  try {
    const { data } = await axios.get(`/api/email-templates/${id}`);
    return data;
  } catch (error) {
    logError(error, 'getEmailTemplateDetails failed');
    return Promise.reject(error.response.data);
  }
};

export const putEmailTemplate = async (
  templateId: string | number,
  templateSections: IEmailTemplateSection[]
): Promise<any> => {
  try {
    const payload = {
      templateSections: templateSections
    };
    const { data } = await axios.put(`/api/email-templates/${templateId}`, payload);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: { templateId: templateId, templateSections: templateSections }
      },
      'putEmailTemplate failed'
    );
    return Promise.reject(error.response.data);
  }
};

export const getSalesEmailTemplates = async (): Promise<IEmailTemplate[]> => {
  try {
    const { data } = await axios.get(`${salesBaseUrl}`);
    return data;
  } catch (error) {
    logError(error, 'getSalesEmailTemplates failed');
    return Promise.reject(error.response.data);
  }
};

export const createSalesEmailTemplate = async (post: ISalesEmailTemplate): Promise<any> => {
  try {
    const { data } = await axios.post(`${salesBaseUrl}`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'createSalesEmailTemplate failed'
    );
    return Promise.reject(error);
  }
};

export const getSalesEmailTemplate = async (
  templateId: string | number
): Promise<ISalesEmailTemplateDetail> => {
  try {
    const { data } = await axios.get(`${salesBaseUrl}/${templateId}`);
    return data;
  } catch (error) {
    logError(error, 'getSalesEmailTemplate failed');
    return Promise.reject(error.response.data);
  }
};

export const updateSalesEmailTemplate = async (
  templateId: string | number,
  payload: ISalesEmailTemplate
): Promise<any> => {
  try {
    const { data } = await axios.put(`${salesBaseUrl}/${templateId}`, payload);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: { templateId: templateId, templateSections: payload }
      },
      'updateSalesEmailTemplate failed'
    );
    return Promise.reject(error.response.data);
  }
};

export const deleteSalesEmailTemplates = async (id: number | string): Promise<any> => {
  try {
    const { data } = await axios.delete(`${salesBaseUrl}/${id}`);
    return data;
  } catch (error) {
    logError(error, 'deleteSalesEmailTemplates failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getEmailTokens = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${salesBaseUrl}/tokens`);

    return data;
  } catch (error: any) {
    logError(error, 'getEmailTokens failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getTransformedEmailTemplates = async (
  emailTemplateId: string,
  buildId: string,
  notificationType?: string
): Promise<ITransformedEmailTemplate> => {
  try {
    const { data } = await axios.get(
      `${salesBaseUrl}/${emailTemplateId}/build/${buildId}/transformed${
        notificationType ? `?notificationType=${notificationType}` : ''
      }`
    );
    return data;
  } catch (error) {
    logError(error, 'getTransformedEmailTemplates failed');
    return Promise.reject(error.response.data);
  }
};

export const addressBookRelationshipTypesQueryKey = 'addressBookRelationshipTypes';
export const getAddressBookRelationshipTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${salesBaseUrl}/address-book-relationship-types`);
    return data;
  } catch (error) {
    logError(error, 'getAddressBookRelationshipTypes failed');
    return Promise.reject(error.response.data);
  }
};
